module.exports = __webpack_public_path__ + "static/media/unibest-solution-img6.65ad934a.png";